import "aos/dist/aos.css";

import About from "./components/about/MainAbout";
import "./App.scss";
import MainBlog from "./components/blog/MainBlog";
import TalkCallToAction from "./components/talk-cta/TalkCallToAction";
import MainSolutions from "./components/solutions/MainSolutions";
import MainChallenges from "./components/challenges/MainChallenges";

const App = () => (
  <>
    <About />
    <MainChallenges />
    <MainSolutions />
    <MainBlog />
    <TalkCallToAction />
  </>
);

export default App;
